import { render, staticRenderFns } from "./confirmed-email.vue?vue&type=template&id=c9fe511e&scoped=true&lang=pug"
import script from "./confirmed-email.vue?vue&type=script&lang=ts"
export * from "./confirmed-email.vue?vue&type=script&lang=ts"
import style0 from "./confirmed-email.vue?vue&type=style&index=0&id=c9fe511e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fe511e",
  null
  
)

export default component.exports